export default __webpack_public_path__ + "static/media/certificate.713be14a.svg";